<template>

    <div class="row">
        <div v-if="loading" class="lds-dual-ring"></div>
        <div v-if="!loading" class="col-lg-12 mb-4">
            <div class="box">
                <div class="box-offset">
                    <div class="box-ttl-wrap">
                        <div class="box-ttl">Call Out</div>

                    </div>
                    <div class="buttons--row buttons--row-2 mb-3">
                        <div class="inner-wrap">
                            <div class="search--block">
                                <button
                                    class="search--block-btn"
                                    type="submit"
                                    @click="handleSearch"
                                >
                                    <img src="/img/svg/icons-search.svg">
                                </button>
                                <input
                                    type="search"
                                    class="search--block-txt"
                                    placeholder="Search by Name"
                                    v-model="filters.search_name"
                                    @input="handleSearch"
                                />
                            </div>
                            <div class="search--block">
                                <button
                                    class="search--block-btn"
                                    type="submit"
                                    @click="handleSearch"
                                >
                                    <img src="/img/svg/icons-search.svg" >
                                </button>
                                <input
                                    type="search"
                                    class="search--block-txt"
                                    placeholder="Search by Property"
                                    v-model="filters.search_property"
                                    @input="handleSearch"
                                />
                            </div>
                            <div class="filter-wrap">
                                <label for="" class="reg-label mr-2">Filter:</label>
                                <div class="form-group form-group-2 mb-0">
                                    <select
                                        class="custom-select"
                                        v-model="filters.doctor_status"
                                        @change="getCallOutList"
                                    >
                                        <option value="all">All</option>
                                        <option value="excused">Excused</option>
                                        <option value="unexcused">Unexcused</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="inner-wrap">
                            <a
                                v-if="possibilityToExport"
                                href="javascript:void(0)"
                                class="btn btn--outline-primary btn--middle"
                                @click="exportCallOuts(callOutList)"
                            ><img src="/img/svg/excel.svg">
                            </a>
                            <a
                                href="/master-admin/call-out/create"
                                class="btn btn--outline-primary btn--middle"
                            >+ Add New</a>
                        </div>
                    </div>
                    <div class="call-nav-tabs">
                        <ul class="nav nav-tabs" id="myTab" role="tablist">
                            <li class="nav-item">
                                <a
                                    class="nav-link"
                                    href="javascript:void(0)"
                                    :class="{ active: activeShift === 'active' }"
                                    @click="handleShifts('active')"
                                >Active Shifts</a>
                            </li>
                            <li class="nav-item">
                                <a
                                    class="nav-link blue"
                                    href="javascript:void(0)"
                                    :class="{ active: activeShift === 'inactive' }"
                                    @click="handleShifts('inactive')"
                                >Inactive Shifts</a>
                            </li>
                        </ul>
                    </div>
                    <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade  show active">
                            <div>
                                <div class="">
                                    <div class="table-holder table-responsive">
                                        <table class="table">
                                            <thead>
                                            <tr>
                                                <th>
                                                    <a href="javascript:void(0)" @click.prevent="changeSortList('date')"> Shift Date<i class="fas fa-sort"></i></a>
                                                </th>
                                                <th>
                                                    <nobr>
                                                        Employee Name
                                                    </nobr>
                                                </th>
                                                <th class="col-min-width">Status</th>
                                                <th>
                                                    <nobr>Shift Information</nobr>
                                                </th>
                                                <th class="text-right">Action</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr
                                                v-for="call in callOutList"
                                                :key="call.id"
                                            >
                                                <td>
                                                    <div class="text-14 color--text-gray">
                                                        {{formatDate(call.open_shift_timestamps)}}
                                                    </div>

                                                </td>
                                                <td>
                                                    <b>{{ call.employee.name }} {{ call.employee.last_name }}</b>
                                                    <div>
                                                        ID: {{ call.employee.applicant_id }}
                                                    </div>
                                                </td>
                                                <td>
                                                        <span :class="{'color--green': call.doctor_status === 'excused', 'color--red': call.doctor_status === 'unexcused'}">
                                                            {{ call.doctor_status | capitalizeFirst }}
                                                        </span>
                                                </td>
                                                <td>
                                                    <div>
                                                        <div class="">
                                                            {{ call.client.name }}
                                                        </div>
                                                        <div class="small-text">
                                                            <span> {{calculateDate(call.open_shift_timestamps)}}</span>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="text-right">
                                                    <div class="action-block">

                                                        <div class="action-block">
                                                            <a :href="`/master-admin/call-out/${call.id}/update`" class="edit-link"><img
                                                                src="/img/svg/icons-pen.svg" alt=""></a>
                                                            <button
                                                                v-if="deletingCallOut"
                                                                class="delete-link"
                                                                @click="showDeleteModal(call.id)"
                                                            ><img src="/img/svg/on.svg" alt="delete">
                                                            </button>

                                                            <ActionModal confirm-text="Yes" reject-text="No"
                                                                         :modalId="getDeleteModalId(call.id)"
                                                                         @confirm="deleteCallOut(call.id)">
                                                                <template #body>
                                                                    <div class="text-center mb-4">
                                                                        <h4>
                                                                            Are you sure you want <br> to delete this
                                                                            item?
                                                                        </h4>
                                                                    </div>
                                                                </template>
                                                            </ActionModal>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <Pagination
                                        class="ml-3 mr-3"
                                        :currentPage="pagination.current_page"
                                        :lastPage="pagination.last_page"
                                        @changeItemsPerPage="changeItemsPerPage"
                                        @changePage="changePage"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import CallOutService from "./services/CallOutService";
import ActionModal from "../../../../../resources/js/components/ActionModal.vue";
import Pagination from "../../../../../resources/js/components/Pagination.vue";
import DateConverter from "../../../../../resources/js/mixins/DateConverter";
import PaginationHandler from "../../../../../resources/js/mixins/PaginationHandler";
import SortDirectionHandler from "../../../../../resources/js/mixins/SortDirectionHandler";
import ModalHandler from "../../../../../resources/js/mixins/ModalHandler";
import ExportHandler from "../../../../../resources/js/mixins/ExportHandler";
import {createDebouncedFunction} from "../../../../../resources/js/plugins/debounce";

export default {
    name: 'CallOutList',
    props: {
        possibilityToExport: {
            type: Boolean,
            required: true
        } ,
        deletingCallOut: {
            type: Boolean,
            required: true
        }
    },
    components: {
        ActionModal,
        Pagination
    },
    mixins: [DateConverter, PaginationHandler, SortDirectionHandler, ModalHandler, ExportHandler],
    data() {
        return {
            export_call_outs: [],
            activeShift: 'active',
            loading: true,
            callOutList: [],
            filters: {
                search_name: '',
                search_property: '',
                doctor_status: 'all',
                shift: 'active',
                sortBy: 'date',
                sortDir: 'asc',
                page: 1,
                perPage: 10,
            },
            pagination: {
                current_page: 1,
                last_page: 1,
            },
        }
    },
    methods: {
        handleSearch() {
            this.filters.page = 1
            this.delayedSearch();
        },

        getList(filters) {
            this.getCallOutList(filters)
        },
        async exportCallOuts(callOutList) {
            let export_call_outs = callOutList.map(call => (call.id))
            const dataToSend = {
                'export_call_outs': export_call_outs
            };
            try {
                const response =  await CallOutService.exportCallOutsData(dataToSend)
                this.createExportFile(response, 'call_out_')

            } catch(error) {
                console.error(error)
                this.$showErrorMessage();
            }
        },
        async deleteCallOut(id) {
            this.$showLoadingMessage()
            this.callOutList = this.callOutList.filter((call) => call.id !== id)
            try {
                await CallOutService.deleteCallOut(id)
                this.$showSuccessMessageDelete();
            } catch (error) {
                this.$showErrorMessage('The Call Out was not deleted. Please reload page try again.');
            }
        },
        async getCallOutList() {
            try {
                const {data: callOuts} = await CallOutService.getCallOutInfo(this.filters)
                this.callOutList = callOuts.data
                this.pagination.current_page = callOuts.current_page
                this.pagination.last_page = callOuts.last_page
                this.loading = false
            } catch (e) {
                this.$showErrorMessage();
            }
        },
        handleShifts(shiftType) {
            this.activeShift = shiftType;

            if (shiftType === 'active') {
                this.filters.shift = 'active'
            } else {
                this.filters.shift = 'inactive'
            }
            this.getCallOutList()

        },
    },
    mounted() {
        this.getCallOutList();
        this.delayedSearch = createDebouncedFunction(() => this.getCallOutList(), 500);
    }

}

</script>


<style scoped>

</style>
